/**
 * Rückfrage vor dem Deaktivieren einer Erweiterung.
 *
 * Bisher genügte ein Klick auf den Schalter, und die Erweiterung war aus —
 * ohne Rückfrage und ohne Hinweis darauf, was damit ausfällt. Bei
 * OpenFormulare ist die Tragweite gross: keine Mandantendialoge, kein Versand
 * von Bewertungsbögen, keine Rückholung abgegebener Bewertungen
 * (qs/dino-qs#9, TF17).
 *
 * Das Aktivieren bleibt ohne Rückfrage — es nimmt nichts weg.
 */

/** Folgen je Erweiterung, in der Sprache der Anwender. */
const CONSEQUENCES: Record<string, string[]> = {
  open_formulare: [
    'Mandanten können keine Dialoge mehr ausfüllen; bereits versandte Links funktionieren nicht mehr.',
    'Bewertungsbögen werden nicht mehr versendet — auch nicht über den automatischen Auslöser.',
    'Bereits abgegebene Bewertungen werden nicht mehr abgeholt und erscheinen nicht in der Auswertung.',
  ],
};

/** Was ohne diese Erweiterung ausfällt. Leer, wenn nichts Besonderes bekannt
 *  ist — dann bleibt die allgemeine Rückfrage. */
export const deactivationConsequences = (systemKey: string): string[] =>
  CONSEQUENCES[systemKey] ?? [];

/**
 * Text der Rückfrage. Nennt die Folgen einzeln, damit die Entscheidung
 * bewusst fällt, und sagt, dass sie umkehrbar ist — sonst traut sich niemand.
 */
export const deactivationConfirmationText = (
  appName: string,
  systemKey: string
): string => {
  const consequences = deactivationConsequences(systemKey);
  const intro = `„${appName}" wird deaktiviert.`;
  const outro =
    'Die Einstellungen bleiben erhalten; die Erweiterung lässt sich jederzeit wieder aktivieren.';

  if (consequences.length === 0) {
    return `${intro} Alle Funktionen dieser Erweiterung stehen danach nicht mehr zur Verfügung. ${outro}`;
  }
  return `${intro} Danach gilt: ${consequences.join(' ')} ${outro}`;
};
